//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Paper } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { searchPaymentAdvertising } from '@payment'

export default {
  components: {
    Paper,
  },

  computed: {
    ...mapGetters({
      paymentMethods: 'countryConfig/paymentMethods',
    }),

    advertising() {
      return searchPaymentAdvertising(this.paymentMethods)
    },
  },
}
